module.exports = __webpack_public_path__ + "img/bcmlogo.a1a4bb31.png";